import {
  GET_PLACE_OTA_DATA,
  GET_PLACE_OTA_DATA_FAILED,
  GET_PLACE_OTA_DATA_SUCCESS,
  GET_ROOM_PRICE_TYPES,
  GET_ROOM_PRICE_TYPES_FAILED,
  GET_ROOM_PRICE_TYPES_SUCCESS,
  UPDATE_ROOM_PRICE_TYPES,
  UPDATE_ROOM_PRICE_TYPES_FAILED,
  UPDATE_ROOM_PRICE_TYPES_SUCCESS,
} from './actionTypes';

const initialState = {
  isLoadingGetPlaceOtaData: false,
  isLoadingGetRoomPriceTypes: false,
  isLoadingUpdateRoomPriceTypes: false,
  placeOtaData: [],
  roomPriceTypes: [],
};

export default function roomPriceType(state = initialState, action) {
  switch (action.type) {
    case GET_ROOM_PRICE_TYPES:
      return {
        ...state,
        isLoadingGetRoomPriceTypes: true,
      };

    case GET_PLACE_OTA_DATA:
      return {
        ...state,
        isLoadingGetPlaceOtaData: true,
      };

    case GET_ROOM_PRICE_TYPES_SUCCESS:
      return {
        ...state,
        isLoadingGetRoomPriceTypes: false,
        roomPriceTypes: action.payload || [],
      };

    case GET_PLACE_OTA_DATA_SUCCESS:
      return {
        ...state,
        isLoadingGetPlaceOtaData: false,
        placeOtaData: action.payload?.Rooms || [],
      };

    case UPDATE_ROOM_PRICE_TYPES:
      return {
        ...state,
        isLoadingUpdateRoomPriceTypes: true,
      };

    case UPDATE_ROOM_PRICE_TYPES_SUCCESS:
      return {
        ...state,
        isLoadingUpdateRoomPriceTypes: false,
      };

    case GET_ROOM_PRICE_TYPES_FAILED:
      return {
        ...state,
        isLoadingGetRoomPriceTypes: false,
        roomPriceTypes: [],
      };

    case GET_PLACE_OTA_DATA_FAILED:
      return {
        ...state,
        isLoadingGetPlaceOtaData: false,
        placeOtaData: [],
      };

    case UPDATE_ROOM_PRICE_TYPES_FAILED:
      return {
        ...state,
        isLoadingUpdateRoomPriceTypes: false,
      };

    default:
      return state;
  }
}
